<template>
  <div class="container-fluid">
    <Header />
    <main class="page-main">
      <slot></slot>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/layout/Header.vue";
import Footer from "../components/layout/Footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
  mounted() {
    // console.log(this.$route.name)
  }
};
</script>